import { StrainState } from "@/vuex/modules/inventory/strain/strain.types";

export const state: StrainState = {
  strains: [],
  loading: false,
  pagination: null,
  editVendor: null
};
